/** Truncates `text` to at most `maxLength` characters, appending "…" if trimmed. */
export function ellipsis(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength).trimEnd() + "…";
}
